module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'changePasswordDialog' + _vm._uid,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.PW0014))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputOldPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.oldPassword),
      expression: "passwords.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputOldPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "oldPassword", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPassword),
      expression: "passwords.newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPassword", $event.target.value)
      }, function($event) {
        _vm.doCheckIfPasswordIsValid(), _vm.checkIfPasswordsMatch()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "2px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPasswordRepeat' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPasswordRepeat),
      expression: "passwords.newPasswordRepeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPasswordRepeat' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPasswordRepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPasswordRepeat", $event.target.value)
      }, function($event) {
        return _vm.checkIfPasswordsMatch()
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "passwordPolicy"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.PW0003))])]), _vm._v(" "), (_vm.passwordPolicy.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.enoughCharacters) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[0].value) + "\n                  " + _vm._s(_vm.lang.PW0005) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasUpperCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[1].value) + "\n                  " + _vm._s(_vm.lang.PW0006) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasLowerCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[2].value) + "\n                  " + _vm._s(_vm.lang.PW0007) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNumbers) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[3].value) + "\n                  " + _vm._s(_vm.lang.PW0008) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNonalphas) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[4].value) + "\n                  " + _vm._s(_vm.lang.PW0009) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordsMatch) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v(_vm._s(_vm.lang.PW0012))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isPasswordValid || !_vm.passwordsMatch
    },
    on: {
      "click": function($event) {
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0011) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e3792d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/ChangePasswordDialog.vue
// module id = 1093
// module chunks = 2